//console.log('☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠ ☠');

// navigation affix
$(function() {
    var header = $('header.header');
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll > 30) {
            header.removeClass('header-transparent');
        } else {
            header.addClass('header-transparent');
        }
    });
});